
// used by fetchAccountPositionsWithAccountValue action and portfolio
// eslint-disable-next-line no-unused-vars
const isTradablePosition = pos => false;

export default isTradablePosition;



// WEBPACK FOOTER //
// ./src/components/Portfolio/isTradablePosition.js